import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import ErrorBoundary from "./components/shared/ErrorBoundary";
import { initializeSentry } from "./monitoring/sentry";

initializeSentry();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js", { updateViaCache: "none" })
      .then((registration) => registration.update())
      .catch(() => {});
  });
} else if ("serviceWorker" in navigator) {
  // A production service worker may remain on a phone after switching to the
  // LAN development URL. Remove it so local testing always uses current code.
  navigator.serviceWorker.getRegistrations()
    .then((registrations) => Promise.all(registrations.map((registration) => registration.unregister())))
    .then(() => window.caches?.keys?.())
    .then((keys) => keys && Promise.all(keys.map((key) => window.caches.delete(key))))
    .catch(() => {});
}
